/* eslint-disable */
import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';
import { BaseRequestModel } from '../models/base-request.model';
import { InstalledEquipmentApiModel, MappedEquipmentApiModel } from './equipments.api';
import { getBaseRequestParams } from '../utils/base-request-params';

@injectable()
export class PartFindApi {
    constructor(private readonly httpClient: HttpClient) {}

    findParts = async (
        data: MappedEquipmentApiModel[],
        installedEquipment?: InstalledEquipmentApiModel,
        cancellationToken?: CancelToken
    ) => {
        return this.httpClient.post<PartResponseModel, PartFindRequestModel>(
            '/part_find',
            {
                ...getBaseRequestParams(),
                mapped_equipments: data,
                monolith_equipment: installedEquipment,
            },
            {
                cancelToken: cancellationToken,
            }
        );
    };

    pricebookMatch = async (
        data: Omit<PartWithId, 'image_url' | 'score'>[],
        cancellationToken?: CancelToken
    ) => {
        return this.httpClient.post<PricebookMatchResponseModel, PricebookMatchRequestModel>(
            '/pricebook_match',
            {
                ...getBaseRequestParams(),
                replacements: data,
            },
            {
                cancelToken: cancellationToken,
            }
        );
    };
}

export interface PartFindRequestModel extends BaseRequestModel {
    mapped_equipments: MappedEquipmentApiModel[];
    monolith_equipment?: InstalledEquipmentApiModel;
}

export interface PartResponseModel {
    part: {
        [key: string]: PartModel;
    };
    replacement: {
        [key: string]: string[];
    };
}

export interface PartModel {
    brand: string;
    number: string;
    subcategory: string;
    image_url?: string;
    score?: number | null;
}

export type PartWithId = PartModel & { id: string };

export interface PricebookMatchRequestModel {
    replacements: (PartModel & { id: string })[];
}

export interface PricebookMatchResponseModel extends BaseRequestModel {
    matched_parts: PricebookMatchItem[];
}

export interface PricebookMatchItem {
    bluon_id: string;
    id: string;
    code: string;
    name: string;
    cost: number;
    price: number;
    description: string;
    supplier_name: string;
    type: number;
    quality: number;
}
